// @ts-nocheck
import React from 'react';
import { Navigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';

export function getCurrentRole() {
  const token = sessionStorage.getItem('jwt');
  if (!token) return '';
  try {
    return jwtDecode(token)?.authorities?.[0]?.authority || '';
  } catch {
    return '';
  }
}

export function getRoleHome(role = getCurrentRole()) {
  if (role === 'ADMIN') return '/admin/dashboard';
  if (role === 'COMPANY') return '/company/dashboard';
  if (role === 'USER') return '/dashboard';
  return '/login';
}

export default function RoleRoute({ allow, children }) {
  const role = getCurrentRole();
  if (!allow.includes(role)) {
    return <Navigate to={getRoleHome(role)} replace />;
  }
  return children;
}
